import { render, staticRenderFns } from "./AdyenBancontactCardForm.vue?vue&type=template&id=4acc8a18&"
import script from "./AdyenBancontactCardForm.vue?vue&type=script&lang=js&"
export * from "./AdyenBancontactCardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports